import {
  FileDoc,
  FileGeneral,
  FileJpg,
  FilePdf,
  FilePng,
  FilePpt,
  FileXls,
  FileZip,
} from "shared/assets/icons";

import { IExtension } from "shared/types";

export const getFileIcon = (extensions: IExtension | string) => {
  switch (extensions) {
    case IExtension.doc:
    case IExtension.docx:
      return FileDoc;
    case IExtension.jpg:
    case IExtension.jpeg:
      return FileJpg;
    case IExtension.pdf:
      return FilePdf;
    case IExtension.png:
      return FilePng;
    case IExtension.ppt:
    case IExtension.pptx:
      return FilePpt;
    case IExtension.xls:
    case IExtension.xlsx:
      return FileXls;
    case IExtension.zip:
      return FileZip;
    default:
      return FileGeneral;
  }
};
